import {
  ReFulfillmentBillingMode,
  reFulfillmentShippingMarkupDefault,
  type ReFulfillmentShippingMarkupConfig,
} from "@redotech/redo-fulfillment-settings/re-fulfillment";
import { hasAnyRefulfillmentEnabledCenter } from "@redotech/redo-return-settings-primitives-common/returns-center-config";

export function reFulfillmentShippingMarkupTeamToFormValue(
  config: ReFulfillmentShippingMarkupConfig | undefined,
): ReFulfillmentShippingMarkupFormValue {
  return {
    markupMode:
      config?.markupMode ?? reFulfillmentShippingMarkupDefault.markupMode,
    markupPercentage:
      config?.markupPercentage ??
      reFulfillmentShippingMarkupDefault.markupPercentage,
    markupAmount: (
      config?.markupAmount ?? reFulfillmentShippingMarkupDefault.markupAmount
    ).toString(),
  };
}

export function resolveReFulfillmentShippingMarkupForSave({
  currentShippingMarkup,
  formValue,
  redoManagedReturnsEnabled,
  returnsCenters,
}: ResolveReFulfillmentShippingMarkupForSaveOptions):
  | ReFulfillmentShippingMarkupConfig
  | undefined {
  if (
    !redoManagedReturnsEnabled ||
    !hasAnyRefulfillmentEnabledCenter(returnsCenters)
  ) {
    return currentShippingMarkup;
  }

  return {
    markupMode:
      formValue.markupMode === "fixed"
        ? ReFulfillmentBillingMode.FIXED
        : ReFulfillmentBillingMode.PERCENTAGE,
    markupPercentage: formValue.markupPercentage,
    markupAmount: Number(formValue.markupAmount) || 0,
  };
}

export interface ReFulfillmentShippingMarkupFormValue {
  markupMode: "percentage" | "fixed";
  markupPercentage: number;
  markupAmount: string;
}

interface ResolveReFulfillmentShippingMarkupForSaveOptions {
  currentShippingMarkup: ReFulfillmentShippingMarkupConfig | undefined;
  formValue: ReFulfillmentShippingMarkupFormValue;
  redoManagedReturnsEnabled: boolean;
  returnsCenters: { refulfillment?: boolean }[] | null | undefined;
}
